import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
import { getNativeContext } from '../helpers/get-native-context';
import { setInternalState } from '../helpers/set-internal-state';
import { wrapEventListener } from '../helpers/wrap-event-listener';
var DEFAULT_OPTIONS = {
  buffer: null,
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  // Bug #149: Safari does not yet support the detune AudioParam.
  loop: false,
  loopEnd: 0,
  loopStart: 0,
  playbackRate: 1
};
export var createAudioBufferSourceNodeConstructor = function createAudioBufferSourceNodeConstructor(createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(AudioBufferSourceNode, _noneAudioDestination);

      function AudioBufferSourceNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, AudioBufferSourceNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, mergedOptions);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var audioBufferSourceNodeRenderer = isOffline ? createAudioBufferSourceNodeRenderer() : null;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(AudioBufferSourceNode).call(this, context, 'passive', nativeAudioBufferSourceNode, audioBufferSourceNodeRenderer));
        _this._audioBufferSourceNodeRenderer = audioBufferSourceNodeRenderer;
        _this._isBufferNullified = false;
        _this._isBufferSet = false;
        _this._nativeAudioBufferSourceNode = nativeAudioBufferSourceNode;
        _this._onended = null; // Bug #73: Edge & Safari do not export the correct values for maxValue and minValue.

        _this._playbackRate = createAudioParam(_assertThisInitialized(_this), isOffline, nativeAudioBufferSourceNode.playbackRate, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
        return _this;
      }

      _createClass(AudioBufferSourceNode, [{
        key: "start",
        value: function start() {
          var _this2 = this;

          var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var duration = arguments.length > 2 ? arguments[2] : undefined;

          this._nativeAudioBufferSourceNode.start(when, offset, duration);

          if (this._audioBufferSourceNodeRenderer !== null) {
            this._audioBufferSourceNodeRenderer.start = duration === undefined ? [when, offset] : [when, offset, duration];
          } else {
            setInternalState(this, 'active');

            var setInternalStateToInactive = function setInternalStateToInactive() {
              _this2._nativeAudioBufferSourceNode.removeEventListener('ended', setInternalStateToInactive); // @todo Determine a meaningful delay instead of just using one second.


              setTimeout(function () {
                return setInternalState(_this2, 'passive');
              }, 1000);
            };

            this._nativeAudioBufferSourceNode.addEventListener('ended', setInternalStateToInactive);
          }
        }
      }, {
        key: "stop",
        value: function stop() {
          var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          this._nativeAudioBufferSourceNode.stop(when);

          if (this._audioBufferSourceNodeRenderer !== null) {
            this._audioBufferSourceNodeRenderer.stop = when;
          }
        }
      }, {
        key: "buffer",
        get: function get() {
          if (this._isBufferNullified) {
            return null;
          }

          return this._nativeAudioBufferSourceNode.buffer;
        },
        set: function set(value) {
          // Bug #71: Edge does not allow to set the buffer to null.
          try {
            this._nativeAudioBufferSourceNode.buffer = value;
          } catch (err) {
            if (value !== null || err.code !== 17) {
              throw err; // tslint:disable-line:rxjs-throw-error
            } // This will modify the buffer in place. Luckily that works in Edge and has the same effect as setting the buffer to null.


            if (this._nativeAudioBufferSourceNode.buffer !== null) {
              var buffer = this._nativeAudioBufferSourceNode.buffer;
              var numberOfChannels = buffer.numberOfChannels;

              for (var i = 0; i < numberOfChannels; i += 1) {
                buffer.getChannelData(i).fill(0);
              }

              this._isBufferNullified = true;
            }
          } // Bug #72: Only Chrome, Edge & Opera do not allow to reassign the buffer yet.


          if (value !== null) {
            if (this._isBufferSet) {
              throw createInvalidStateError();
            }

            this._isBufferSet = true;
          }
        }
      }, {
        key: "onended",
        get: function get() {
          return this._onended;
        },
        set: function set(value) {
          var wrappedListener = wrapEventListener(this, value);
          this._nativeAudioBufferSourceNode.onended = wrappedListener;
          var nativeOnEnded = this._nativeAudioBufferSourceNode.onended;
          this._onended = nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
      }, {
        key: "loop",
        get: function get() {
          return this._nativeAudioBufferSourceNode.loop;
        },
        set: function set(value) {
          this._nativeAudioBufferSourceNode.loop = value;
        }
      }, {
        key: "loopEnd",
        get: function get() {
          return this._nativeAudioBufferSourceNode.loopEnd;
        },
        set: function set(value) {
          this._nativeAudioBufferSourceNode.loopEnd = value;
        }
      }, {
        key: "loopStart",
        get: function get() {
          return this._nativeAudioBufferSourceNode.loopStart;
        },
        set: function set(value) {
          this._nativeAudioBufferSourceNode.loopStart = value;
        }
      }, {
        key: "playbackRate",
        get: function get() {
          return this._playbackRate;
        }
      }]);

      return AudioBufferSourceNode;
    }(noneAudioDestinationNodeConstructor)
  );
};